import { render, staticRenderFns } from "./cusSerList.vue?vue&type=template&id=7bbb1386&scoped=true"
import script from "./cusSerList.vue?vue&type=script&lang=js"
export * from "./cusSerList.vue?vue&type=script&lang=js"
import style0 from "./cusSerList.vue?vue&type=style&index=0&id=7bbb1386&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbb1386",
  null
  
)

export default component.exports